<template>
  <div class="hr-notes">
    <h3 class="hr-notes__title">
      <span>HR Notes</span>
      <v-btn
        class="hr-notes__edit-btn"
        outlined
        fab
        tile
        x-small
        color="blue"
        @click="showNotesModal"
      >
        <v-icon dark>mdi-square-edit-outline</v-icon>
      </v-btn>
    </h3>

    <div v-if="notes"
      class="hr-notes__content">
      {{ limitText(notes, 700) }}
      <span v-if="notes.length > 700"
        class="hr-notes__read-more"
        @click="showNotesModal">
        Read more
      </span>
    </div>

    <EmptyState
      v-else
      title="You can add your notes here"
      description="Notes are only visible for hr in the developer profile"
      outlined
      @click="showNotesModal" />

    <NotesModal v-model="isNotesModalVisible" />
  </div>
</template>

<script>
import EmptyState from '@/components/Developers/Show/EmptyState.vue';
import NotesModal from '@/components/Developers/Show/NotesModal.vue';

export default {
  components: {
    EmptyState,
    NotesModal,
  },

  props: {
    notes: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      isNotesModalVisible: false,
    };
  },

  methods: {
    showNotesModal() {
      this.isNotesModalVisible = true;
    },

    limitText(str, limit) {
      return str.length > limit ? str.substr(0, limit).concat('...') : str;
    },
  },
};
</script>

<style lang="scss" scoped>
.hr-notes {
  margin-bottom: 24px;
  padding: 16px 24px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 8px;

  &:hover .hr-notes__edit-btn {
    opacity: 1;
  }

  &__title {
    color: $main--headers;
    font-size: 18px;
    line-height: 21px;
    font-weight: 500;
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__edit-btn {
    border-radius: 4px;
    border-color: $color--secondary;
    opacity: 0;
    transition: all 0.4s ease;
  }

  &__content {
    letter-spacing: 0;
    color: rgba(57,70,87,0.7);
    margin-bottom: 4px;
    font-weight: 300;
    word-break: break-word;
  }

  &__read-more {
    color: $color--blue;
    margin-left: 4px;
    font-weight: 600;
    cursor: pointer;
  }
}
</style>
